import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../atoms/Icon';
import ImagePreloader from '../../../utils/ImagePreloader';
import ColorFinder from '../../../utils/ColorFinder';


/**
 * A simple OptionsDisplay.
 */

const shyLabel = label => {
	return label.split('/').join(' / ');
};

const getLabel = label => {
  var str = label.toLowerCase();
  if(str==='versicherung wg') {
    return "Wertgarantie";
  }
  return label;
}

class OptionsDisplay extends React.Component {
	 constructor(props) {
      super(props);
      this.mouseOver = this.mouseOver.bind(this);
      this.mouseOut = this.mouseOut.bind(this);
      this.insuranceInfo = this.insuranceInfo.bind(this);
      this.state = {
        info: false
      };
    }
	getPreview() {
		if(this.props.type==='image') {
			return <ImagePreloader alt={this.props.choice.preview} src={this.props.choice.preview} useAsBg={true} />;
		}
		let color = ColorFinder.get(this.props.choice.preview);
		if(color.valid) {
			return <div className="color" style={{backgroundColor:color.rgb}}></div>;
		}
		return <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=" alt="blank" />
	}
	mouseOver() {
		this.setState({info:true});
	}
	mouseOut() {
		this.setState({info:false});
	}
	insuranceInfo() {
		this.props.showInfo(this.props.typeOfInsurance, this.props.isGostudent);
	}
    render () {
    	const label = getLabel(this.props.label);
        return (
        <div className="optionscontainer">

        	<div className="label">{label}</div>
	          <div className="optionsdisplay selected">
	            <Icon filename="selected" />
	            <div className="inner">
	            	<div className={`preview ${this.props.type}`}>
	              		{this.getPreview()}
	              	</div>
	              	<div className="label">
	              		{shyLabel(this.props.choice.label)}
	              	</div>
	            </div>
	          </div>
	          {this.props.isInsurance &&
	        	<div>
	        		<Icon filename="information" onMouseOver={() => this.mouseOver()} onMouseOut={() => this.mouseOut()} onClick={this.insuranceInfo}/>
	        		<div className={`insurancehint${this.state.info?" active":""}`}>Klicken für Versicherungs&shy;bedingungen</div>
	        	</div>}
				{this.props.isGostudent &&
        	<div>
        		<Icon filename="information" onMouseOver={() => this.mouseOver()} onMouseOut={() => this.mouseOut()} onClick={this.insuranceInfo}/>
        		<div className={`insurancehint${this.state.info?" active":""}`}>Klicken für Gostudent Bedingungen</div>
        	</div>}
        </div>
        );
    }

}

OptionsDisplay.propTypes = {
	/** preview type */
	type: PropTypes.string,
	/** label */
	label: PropTypes.string,
	/** Button label */
	choice: PropTypes.object.isRequired
}

OptionsDisplay.defaultProps = {
	type: ''
	
}


export default OptionsDisplay;





// WEBPACK FOOTER //
// ./src/components/molecules/OptionsDisplay/OptionsDisplay.js